/* eslint-disable */

import adminSidebar from '@/components/admin-sidebar/index';
import appFooter from '@/components/footer/index';
import {bus} from '@/main';

var $ = window.jQuery = require('jquery');

export default {
  name: 'admin',
  components: {
    'admin-sidebar': adminSidebar,
    'app-footer': appFooter,
  },
  props: [],
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {
    bus.$emit('authBtnShowBus', true)
    $('.app-loader').hide();
  },
  methods: {

  }
}